import React, { Component } from "react";
import {
  profile,
  GET,
  PUT,
  alert,
  loading,
  tokens,
  twofa,
  Modal,
  format_date,
  toFixed,
  total,
} from "../components/CustomComponent";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_profile: null,
      array_link: [
        { title: "Report" },
        {
          name: "ติดต่อ/ใบเสนอราคา",
          icon: "\uf0ac",
          link: "/admin/contact",
          role: "super_user,admin,sale",
        },
        { title: "ตั้งค่า", role: "super_user,admin" },
        { name: "สินค้า", icon: "\uf468", link: "/admin/product", role: "super_user,admin" },
        {
          name: "ตั้งค่าอื่นๆ",
          icon: "\uf013",
          link: "/admin/setting",
          role: "super_user",
        },
      ],
    };
  }

  icon = (io) => <span className="icon">{io}</span>;

  componentDidMount = async () => {
    this.setState({user_profile: profile})
  };

  componentMenu = () => {
    const classNameBTN =
      "btn btn-outline-dark border-0 w-100 text-start d-flex align-items-center justify-content-start p-1 mb-1 rounded-3";
    const classNameICON =
      "icon wpx-30 hpx-30 ms-1 d-flex align-items-center justify-content-center";
    const currentPath = `/${window.location.href.split("/").pop()}`;
    const linkItem = (href, icon, label, isActive, extra = null) => (
      <a
        href={href}
        className={`${classNameBTN} ${isActive ? "active" : ""}`}
        style={{ borderRadius: 12 }}
      >
        <span className={classNameICON} style={{ borderRadius: 10 }}>
          {icon}
        </span>
        <div className="mx-2">{label}</div>
        {extra}
      </a>
    );

    const { array_link,user_profile } = this.state;

    return (
      <div className="pb-5">
        {array_link.filter(e=>(e.role)?.includes(user_profile?.ut)).map((item, i) => {
          if (item.title)
            return (
              <div className="my-2 text-12" key={`title-${i}`}>
                <b>{item.title}</b>
              </div>
            );
          const params = [`type=${item.type}`]?.filter(Boolean).join("&");
          const href = `${item.link}${
            item.type || item.country ? "?" + params : ""
          }`;
          const isActive = href === currentPath;
          return linkItem(
            `${href}`,
            item.icon,
            item.name,
            isActive,
            item.component
          );
        })}

        <hr />
        <div className="d-block d-xl-none">
          <button
            className={`${classNameBTN} text-danger`}
            style={{ borderRadius: 16 }}
            onClick={async () => {
              localStorage.removeItem("scp-profile");
              window.location.href = "/";
            }}
          >
            <span className={classNameICON} style={{ borderRadius: 12 }}>
              {"\uf2f5"}
            </span>
            <div className="mx-2">Logout</div>
          </button>
        </div>
      </div>
    );
  };
  Logout = async () => {
    if (
      await alert(
        "",
        "warning",
        "Confirm",
        "Press 'Logout' to confirm leaving this app?",
        "Logout",
        "cancel"
      )
    ) {
      loading(true);
      localStorage.removeItem("scp-profile");
      window.location.href="/";
      loading(false);
    }
  };

  render() {
    const { user_profile } = this.state;
    return (
      <div className="hpx-50">
        <Navbar
          className="px-3 px-xl-4 bg-light position-fixed w-100"
          style={{ zIndex: 1020 }}
          expand="xl"
        >
          <Navbar.Brand href="/" className="fw-bold text-dark">
            <div className="position-relative">
              <img
                alt="logo"
                src={LOGO}
                height={25}
                style={{ objectFit: "contain" }}
                className="pointer"
                onClick={() => {
                  window.location.href = `/`;
                }}
              />
            </div>
          </Navbar.Brand>
          <Navbar.Toggle
            className="border-0"
            aria-controls="basic-navbar-nav"
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <div className="d-none d-xl-flex align-items-center">
                <div
                  className="hpx-40 mx-2 bg-secondary-light"
                  style={{ width: 1 }}
                />
                <div className="d-none d-xl-flex align-items-center text-start">
                  <span className="bg-warning text-dark me-1 wpx-30 hpx-30 rounded-circle d-flex align-items-center justify-content-center">
                    {user_profile?.fn?.slice(0, 2).toUpperCase() || "US"}
                  </span>
                  <div className="px-2">
                    <div className="text-14">
                      {user_profile?.fn || "Username"}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="d-block d-xl-none mb-5 pt-4 overflow-scroll"
                style={{ height: "80vh" }}
              >
                {this.componentMenu()}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <div
          className="position-fixed wpx-260 bg-light overflow-scroll d-none d-xl-block border-secondary-light"
          style={{
            zIndex: 1021,
            height: "100vh",
          }}
        >
          <div className="d-flex pt-3 position-fixed bg-light pb-4 px-3 wpx-260 border-secondary-light">
            <div className="position-relative">
              <img
                alt="logo"
                src={LOGO}
                height={25}
                style={{ objectFit: "contain" }}
                className="pointer"
              />
            </div>
          </div>
          <div className="px-3 mb-5" style={{ marginTop: 70 }}>
            {this.componentMenu()}
          </div>
          <div
            className="d-flex pt-2 position-fixed bg-light pb-3 px-3 wpx-260 border-secondary-light"
            style={{
              bottom: 0,
            }}
          >
            <div className="d-flex align-items-center text-start w-100">
              <span className="bg-warning text-dark me-1 wpx-30 hpx-30 rounded-circle d-flex align-items-center justify-content-center">
                {user_profile?.fn?.slice(0, 2).toUpperCase() || "US"}
              </span>
              <div className="px-2 w-100">
                <div className="text-14">
                  {user_profile?.fn || "Username"}
                </div>
              </div>
              <span
                className="icon p-2 pointer"
                onClick={() => {
                  this.Logout();
                }}
              >
                {"\uf08b"}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
